
        <ng-content select="collapsible-header"></ng-content>
        <ng-content select="collapsible-body"></ng-content>
    


// WEBPACK FOOTER //
// ./node_modules/angular2-collapsible/angular2-collapsible.d.ts.CollapsibleListItemComponent.html